export default __webpack_public_path__ + "static/media/picture01.0e111bcc.GIF";